






























































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import ModableContainer from "@/components/ModableContainer.vue";
import BaseTable from "@/components/BaseTable.vue";
import LineGraph, {
  LineGraphData,
  LineGraphPlotPoint,
  LineGraphSection
} from "@/components/LineGraph.vue";
import StateContainer, { State } from "@/components/StateContainer.vue";
import SubcategoryColorIcon from "@/components/SubcategoryColorIcon.vue";

export interface LineGraphTableEntry {
  date: string;
  value: string;
}

export interface LineGraphTableData extends LineGraphSection {
  data: LineGraphTableEntry[];
}

@Component({
  components: {
    ModableContainer,
    BaseTable,
    LineGraph,
    StateContainer,
    SubcategoryColorIcon
  }
})
export default class GraphPanel extends Vue {
  @Prop({ default: State.okay }) private state?: State;
  @Prop() private title?: string;
  @Prop() private data?: LineGraphData[];
  @Prop() private modalTitle?: string;
  @Prop({ default: "-" }) private emptyCell!: string;
  @Provide() private State = State;
  @Provide() private showLineGraphModal = false;
  @Provide() private isEmpty = this.data ? this.data.length === 0 : true;
  @Provide() private tableData: LineGraphTableData[] = this.generateTableData(
    this.data
  );

  @Watch("data")
  onDataChanged() {
    this.isEmpty = this.data ? this.data.length === 0 : true;
    this.tableData = this.generateTableData(this.data);
  }

  get dates() {
    return this.$store.state.config.dates;
  }

  generateTableData(data?: LineGraphData[]): LineGraphTableData[] {
    if (!data) {
      return [];
    }
    const rowFormatter = this.tableRowFormatter(data);
    return data.map(row => rowFormatter(row));
  }

  generateDefaultTableRow(data: LineGraphData[]): { [date: string]: string } {
    return data.reduce(
      (accDates: { [date: string]: string }, section: LineGraphData) => {
        return {
          ...accDates,
          ...section.data.reduce(
            (
              acc: { [date: string]: string },
              { date }: LineGraphPlotPoint
            ) => ({
              ...acc,
              [date]: this.emptyCell
            }),
            {}
          )
        };
      },
      {}
    );
  }

  tableRowFormatter(data: LineGraphData[]) {
    const defaultRow = this.generateDefaultTableRow(data);
    return (graphRow: LineGraphData) => {
      const tableRow = graphRow.data.reduce(
        (
          acc: { [date: string]: string },
          { date, value }: LineGraphPlotPoint
        ) => ({
          ...acc,
          [date]: value
        }),
        defaultRow
      );
      return {
        ...graphRow,
        data: Object.keys(tableRow).map(key => ({
          date: key,
          value: tableRow[key]
        }))
      };
    };
  }

  handleLineGraphModalOpen() {
    this.showLineGraphModal = true;
  }

  handleLineGraphModalClose() {
    this.showLineGraphModal = false;
  }
}
